import React, { useContext, useState } from 'react';
import {
    Modal, ModalHeader, ModalBody, Form, FormGroup, Label,
    Input, Button
} from 'reactstrap';

import { AuthContext } from '../../context/AuthContext';
import { TipoTerceiroContext } from '../../context/TipoTerceiro';
import { CreateTipoTerceiroType } from '../../context/hooks/useTipoTerceiro';

interface Props {
    isOpen: boolean;
    toggle: () => void;
    onCreated?: () => void;
}

export const CreateTipoTerceiroModal: React.FC<Props> = ({
    isOpen,
    toggle,
    onCreated
}) => {
    const { objUserTk } = useContext(AuthContext);
    const { createTipoTerceiro } = useContext(TipoTerceiroContext);

    const [formData, setFormData] = useState<CreateTipoTerceiroType>({
        type: '',
        empresaId: objUserTk.EmpresaId
    });

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        const ok = await createTipoTerceiro(formData);
        if (ok) {
            onCreated?.();
            toggle();
            setFormData({ type: '', empresaId: objUserTk.EmpresaId });
        }
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} backdrop="static" size="lg">
            <ModalHeader toggle={toggle}>Adicionar novo tipo de terceiro</ModalHeader>
            <ModalBody>
                <Form onSubmit={handleSubmit}>
                    <FormGroup>
                        <Label className="form-control-label" htmlFor="type">
                            Tipo de terceiro
                        </Label>
                        <Input
                            className="form-control-alternative"
                            id="type"
                            name="type"
                            value={formData.type}
                            onChange={handleChange}
                            placeholder="Ex: Fotógrafo, Logística…"
                            required
                        />
                    </FormGroup>

                    <div className="d-flex justify-content-end mt-3">
                        <Button style={{ background: '#585858', color: '#fff' }} type="submit">
                            Criar Tipo de Terceiro
                        </Button>
                        <Button
                            style={{ background: '#d9534f', color: '#fff' }}
                            className="ml-2"
                            onClick={toggle}
                        >
                            Cancelar
                        </Button>
                    </div>
                </Form>
            </ModalBody>
        </Modal>
    );
};

export default CreateTipoTerceiroModal;